import React, { useEffect, useMemo, useRef } from "react";
import {
  CategoryScale,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  LogarithmicScale,
  PointElement,
  Tooltip,
} from "chart.js";
import Datalabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";
import styled from "styled-components";
import { chart, useTheme } from "@glossy/theme";
import { ChartPolarizeColors } from "../plugins";
import { getFormatedData } from "./data";
import { getOptions } from "./options";
export interface IProps {
  data: number[];
  color?: string;
  polarizeColors?: boolean;
  disableAnimation?: boolean;
}

const Root = styled.div`
  position: relative;
  height: 100%;
`;

const Sparkline = ({
  polarizeColors,
  data,
  color,
  disableAnimation,
}: IProps) => {
  const theme = useTheme();
  const chartRef = useRef(null);
  const _color = color || chart({ theme }, "primary");
  const options = useMemo(
    () => getOptions(polarizeColors, data, disableAnimation),
    [polarizeColors, data, disableAnimation]
  );

  const formatData = useMemo(
    () => getFormatedData(data, _color, polarizeColors),
    [_color, data, polarizeColors]
  );

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
  }, [polarizeColors, data]);

  const plugins = [
    CategoryScale,
    LineElement,
    LinearScale,
    LogarithmicScale,
    PointElement,
    Tooltip,
    Legend,
    Filler,
    Datalabels,
    ChartPolarizeColors,
  ];
  return (
    <Root>
      <Line
        data={formatData}
        options={options}
        ref={chartRef}
        plugins={plugins}
      />
    </Root>
  );
};

export default Sparkline;
